export type UserProperties = Record<
  string,
  string | number | boolean | Array<string | number | boolean>
>

export interface InitExperimentClientParams {
  domainUserId: string
  overrideInstance?: boolean
  userProperties?: UserProperties
}

export interface GetVariantArgs {
  /** Key used to reference the experiment or feature flag */
  experimentKey: string

  /** Variant value to use if none can be determined */
  fallback?: string

  /** If true, calling `getVariant` automatically triggers an exposure event. Defaults to true. */
  trackExposure?: boolean

  /** Include Query Parameters as a source to look for a variant */
  useQueryParams?: boolean
}

export const EXPERIMENT_SOURCES = ['query-params', 'exp-client', 'fallback'] as const
export type ExperimentSource = typeof EXPERIMENT_SOURCES[number]

export interface VariantGetter {
  (experimentKey: string): { source: ExperimentSource; value: string | undefined }
}
